import React, { useEffect, useRef, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { updateProfile } from "../../../../redux/profile/action";
import { useDispatch, useSelector } from "react-redux";
import { GetCountry } from "../../../../redux/master/action";
import { decodeHtml } from "../../../../assests/extention/commonfunction";
import ReactSelect from "react-select";
import { Modal } from "reactstrap";
import ProfileModelBankDetails from "../ProfileModel/ProfileModelBankDetails";
import ProfileModelAddressDetails from "../ProfileModel/ProfileModelAddressDetails";
import { namevalidation, titlevalidation } from "../../../Common/commonvalidation";
import { handleNameKeyDown } from "../../../Common/FewCommonMethods";

const validationSchema = Yup.object().shape({
  first_name: namevalidation,
  last_name: titlevalidation,
  country_id: Yup.number().required("Country is required"),
});

export default function ProfileEdit({ formData }) {
  const dispatch = useDispatch();
  const formikRef = useRef(null);
  const [modelBank, setModelBank] = useState(false);
  const [modelAddress, setModelAddress] = useState(false);
  const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  const [selectCountry, setSelectCountry] = useState(null);

  const countrylist = useSelector(({ master: { countrylist } }) => countrylist);

  useEffect(() => {
    dispatch(GetCountry());
  }, [dispatch]);

  // Find user's country from the list
  const country_index =
    Array.isArray(countrylist) &&
    countrylist.find((item) => item.id == formData?.country_id);

  // Sync selected country with dropdown
  useEffect(() => {
    if (country_index) {
      setSelectCountry({
        value: country_index.id,
        label: `${country_index.title}`,
      });
    }
  }, [country_index]);

  const initialValues = {
    country_id: formData?.country_id || "",
    country_code: formData?.country_code,
    mobile_number: formData?.mobile_number,
    fullmobile_number: `${formData?.country_code} ${formData?.mobile_number}`,
    email_id: formData?.email_id,
    first_name: decodeHtml(formData?.first_name) || "",
    last_name: decodeHtml(formData?.last_name) || "",
  };

  const handleSubmit = (values) => {
    const data = {
      type: "profile",
      first_name: values.first_name,
      last_name: values.last_name,
      country_id: values.country_id,
    };

    dispatch(updateProfile(data));
  };

  const handleNextClick = () => {
    if (formikRef.current) {
      formikRef.current.submitForm();
    }
  };

  return (
    <>
      <div className="profile-first">
        <div>
          <h4>Profile settings</h4>
          <p>Manage your profile information & credentials</p>
        </div>
        <div className="d-flex align-items-center" style={{ columnGap: '12px' }}>
          <button onClick={() => setModelAddress(true)} className="buttons background-button" >
            Address Details
          </button>
          {
            profile?.role_type != 3 && profile?.role_type != 4 && (
              <button onClick={() => setModelBank(true)} className="buttons background-button" >
                Bank Details
              </button>
            )
          }
          <button onClick={handleNextClick} className="buttons background-button">
            Save changes
          </button>
        </div>
      </div>

      <div className="profile-edit">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
          innerRef={formikRef}
        >
          {({ setFieldValue }) => (
            <Form>
              {/* Email */}
              <div className="profile-form row">
                <div className="col-md-6">
                  <h6>Email Address</h6>
                  <p>Email address associated with your account</p>
                </div>
                <div className="col-md-6">
                  <Field
                    disabled={true}
                    type="text"
                    name="email_id"
                    className="form-control"
                    placeholder="Enter Email ID"
                  />
                  <div className="verified">
                    <p>&nbsp;</p>
                    <p>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/common/shield-tick.svg`}
                        alt=""
                      />
                      Verified
                    </p>
                  </div>
                </div>
              </div>

              <br />

              {/* First Name */}
              <div className="profile-form row">
                <div className="col-md-6">
                  <h6>First Name</h6>
                  <p>First name displayed on your profile</p>
                </div>
                <div className="col-md-6">
                  <Field
                    type="text"
                    name="first_name"
                    className="form-control"
                    placeholder="Enter First Name"
                    onKeyDown={handleNameKeyDown}
                  />
                  <ErrorMessage name="first_name" component="div" className="error" />
                </div>
              </div>

              <br />

              {/* Last Name */}
              <div className="profile-form row">
                <div className="col-md-6">
                  <h6>Last Name</h6>
                  <p>Last name displayed on your profile</p>
                </div>
                <div className="col-md-6">
                  <Field
                    type="text"
                    name="last_name"
                    className="form-control"
                    placeholder="Enter Last Name"
                    onKeyDown={handleNameKeyDown}
                  />
                  <ErrorMessage name="last_name" component="div" className="error" />
                </div>
              </div>

              <br />

              {/* Country */}
              <div className="profile-form row">
                <div className="col-md-6">
                  <h6>Country</h6>
                  <p>Country displayed on your profile</p>
                </div>
                <div className="col-md-6">
                  <ReactSelect
                    options={
                      Array.isArray(countrylist)
                        ? countrylist.map((country) => ({
                          value: country.id,
                          label: `${country.title}`,
                        }))
                        : []
                    }
                    placeholder="Select country"
                    value={selectCountry}
                    onChange={(option) => {
                      setSelectCountry(option);
                      setFieldValue("country_id", option.value);
                    }}
                    isDisabled={true}
                  />
                  <ErrorMessage name="country_id" component="div" className="error" />
                </div>
              </div>

              <br />

              {/* Mobile */}
              <div className="profile-form row">
                <div className="col-md-6">
                  <h6>Mobile no.</h6>
                  <p>Mobile no. linked with your account</p>
                </div>
                <div className="col-md-6">
                  <Field
                    disabled={true}
                    type="text"
                    name="fullmobile_number"
                    className="form-control"
                    placeholder="Enter Mobile No"
                  />
                  <div className="verified">
                    <a></a>
                    <p>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/common/shield-tick.svg`}
                        alt=""
                      />
                      Verified
                    </p>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <Modal className="popupmodal yes-no" isOpen={modelBank}>
        <ProfileModelBankDetails
          edittype={1}
          formData={formData}
          setFormData={() => { }}
          setModelBank={setModelBank}
        />
      </Modal>
      <Modal className="popupmodal yes-no" isOpen={modelAddress}>
        <ProfileModelAddressDetails
          edittype={1}
          formData={formData}
          setFormData={() => { }}
          setModelAddress={setModelAddress}
        />
      </Modal>
    </>
  );
}
